import React from 'react';
import classNames from 'classnames';
import styles from './Stepper.module.scss';

export type StepperProgressCircleProps = {
  activeStep: number;
  steps: number;
  isDone?: boolean;
};

export function StepperProgressCircle({ isDone, steps, activeStep }: StepperProgressCircleProps) {
  const progress =
    activeStep > steps && activeStep >= 0 && steps > 0 ? 100 : (activeStep / steps) * 100;

  const radius = 30;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div
      className={classNames(styles.progressCircle, {
        [styles.progressCircleCompleted]: isDone || activeStep > steps,
      })}
    >
      <svg className={styles.progressSvg} width="73" height="73" viewBox="0 0 73 73">
        <circle cx="36.5" cy="36.5" r={radius} fill="none" stroke="#dde3ed" strokeWidth="3" />
        <circle
          cx="36.5"
          cy="36.5"
          r={radius}
          fill="none"
          stroke={isDone || activeStep > steps ? '#34a853' : '#1f61f7'}
          strokeWidth="6"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          transform="rotate(-90 36.5 36.5)"
        />
      </svg>
      <div className={styles.progressSteps}>
        {isDone || activeStep > steps ? (
          <div className={styles.progressDoneIcon}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#ffffff" />
            </svg>
          </div>
        ) : (
          <p>
            {activeStep} de {steps}
          </p>
        )}
      </div>
    </div>
  );
}
